export enum WebsiteBlogType {
  Blog = 'Blog',
  HAP = 'HAP'
}

export type WebsiteBlog = {
  id: number
  createdAt: string
  name: string
  type: WebsiteBlogType
  url: string
  metaTitle: string
  metaDescription: string
  content: any
}

export type WebsiteBlogInput = {
  name: string
  type: WebsiteBlogType
  url: string
  metaTitle: string
  metaDescription: string
  content: any
}

export interface WebsiteBlogFindRequest {
  id?: number
  take?: number
  skip?: number
  name?: string
  url?: string
}

export interface WebsiteBlogPageableResponse {
  count: number
  data: WebsiteBlog[]
}

